angular.
module("dx.webapp.login").
directive("dxLoginForm", function loginFormDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {},
		templateUrl: "tmpl/login/login-form-directive.html",
		controller: "DxLoginFormController",
		controllerAs: "vm",
		bindToControler: true,
	};
});
